import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import VehicleDetailsDialog from './VehicleDetailsDialog';
import { IApplicationState } from 'ducks/reducers';
import { selectors as staffSelectors } from 'ducks/staff';

const mapStateToProps = (state: IApplicationState) => ({
  currentUserId: staffSelectors.id(state) ? staffSelectors.id(state) : ''
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {},
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(VehicleDetailsDialog);
